import { ESortVariants } from '../../types/jsonQuery/sortType';
import { TThunkAction } from '../../types/redux/thunk';
import { createTerm } from '../../utils/jsonQuery/createTerm';
import { mergeJsonQueryAction, setJsonQueryAction } from '../jsonQuery';
import { promosRequestAction } from '../promos/getPromos';

/**
 * Redux action, который запрашивает объявления с новой сортировкий
 * @param {ESortVariants} sorting - новый тип сортировки
 */
export const promosSortingRequestAction =
  (sorting: ESortVariants): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const jsonQuery = getState().jsonQuery;
    try {
      const sortingTerm = {
        sort: createTerm<ESortVariants>(sorting),
      };

      dispatch(mergeJsonQueryAction(sortingTerm));
      dispatch(mergeJsonQueryAction({ page: null }));

      await dispatch(promosRequestAction());
    } catch (e) {
      dispatch(setJsonQueryAction(jsonQuery));
    }
  };
